import { isCubicInstallation } from '@/lib/installations/cubic-installations';

/**
 * Whether a pull request page's sidebar chat may run on a code session in the installation: only
 * in cubic's own installations while the team tries it, so customers keep the sidebar's own chat.
 * The one switch for both sides, so a change ships to both at once: the page asks the server only
 * where this holds (`usePageChatEngine`), which spares customers' pages any wait or request, and
 * the page chat route checks it again before it chooses or starts a session
 * (`resolvePageChatEngine`).
 */
export function isPrPageSessionInstallation(installationId: number): boolean {
  return isCubicInstallation(installationId);
}
